import { createGlobalStyle } from 'styled-components/macro'

import Frutiger55RomanWoff from '../Fonts/FrutigerLTW02-55Roman.woff'
import Frutiger55RomanWoff2 from '../Fonts/FrutigerLTW02-55Roman.woff2'
import Frutiger65BoldWoff from '../Fonts/FrutigerLTW02-65Bold.woff'
import Frutiger65BoldWoff2 from '../Fonts/FrutigerLTW02-65Bold.woff2'
import TTHovesBold from '../Fonts/tt-hoves-bold.woff'
import TTHovesDemiBold from '../Fonts/tt-hoves-demibold.woff'
import TTHovesLight from '../Fonts/tt-hoves-light.woff'
import AvenirNextRegular from '../Fonts/telehealth-avenir-next.woff2'
import AvenirNextDemiBold from '../Fonts/telehealth-avenir-next-demi.woff2'
import AvenirNextBold from '../Fonts/telehealth-avenir-next-bold.woff2'
import LatoRegular from '../Fonts/lato-regular.woff2'
import LatoBold from '../Fonts/lato-bold.woff2'
import SoehneLight from '../Fonts/soehne-web-leicht.woff2'
import SoehneBold from '../Fonts/soehne-web-fett.woff2'
import SoehnePowerful from '../Fonts/soehne-web-kraftig.woff2'

const FontStyles = createGlobalStyle`
  @font-face {
    font-family: 'Frutiger';
    font-style: normal;
    font-weight: 400;
    src: url(${Frutiger55RomanWoff2}) format('woff2'),
      url(${Frutiger55RomanWoff}) format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'Frutiger';
    font-style: normal;
    font-weight: 700;
    src: url(${Frutiger65BoldWoff2}) format('woff2'),
      url(${Frutiger65BoldWoff}) format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'TT Hoves';
    font-style: normal;
    font-weight: 400;
    src: url(${TTHovesLight}) format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'TT Hoves';
    font-style: normal;
    font-weight: 500;
    src: url(${TTHovesDemiBold}) format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'TT Hoves';
    font-style: normal;
    font-weight: 700;
    src: url(${TTHovesBold}) format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'Avenir Next';
    font-style: normal;
    font-weight: 400;
    src: url(${AvenirNextRegular}) format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'Avenir Next';
    font-style: normal;
    font-weight: 500;
    src: url(${AvenirNextDemiBold}) format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'Avenir Next';
    font-style: normal;
    font-weight: 700;
    src: url(${AvenirNextBold}) format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url(${LatoRegular}) format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    src: url(${LatoBold}) format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'Soehne';
    font-style: normal;
    font-weight: 400;
    src: url(${SoehneLight}) format('woff2');
    font-display: swap;
  }
  @font-face {
    font-family: 'Soehne-powerful';
    font-style: normal;
    font-weight: 400;
    src: url(${SoehnePowerful}) format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'Soehne-bold';
    font-style: normal;
    font-weight: 700;
    src: url(${SoehneBold}) format('woff2');
    font-display: swap;
  }
`

export default FontStyles
